import * as actionTypes from "./actionTypes";

const initialState = {
  data: null,
  balanceData: null,
  selects: null,
  isLoading: false,
  startHolidaysOnNonWorkingDay: true,
  allowHalfDayHolidays: true,
  additionalLegalDays: 0,
  hasSignedDocument: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        selects: action.payload.selects,
        startHolidaysOnNonWorkingDay: action.payload.startHolidaysOnNonWorkingDay,
        allowHalfDayHolidays: action.payload.allowHalfDayHolidays,
        additionalLegalDays: action.payload.additionalLegalDays,
        hasSignedDocument: action.payload.hasSignedDocument,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        selects: action.payload.selects,
      };
    case actionTypes.DELETE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        selects: action.payload.selects,
      };
    case actionTypes.CREATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        selects: action.payload.selects,
      };
    case actionTypes.MODIFY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DOWNLOAD:
      return { ...state, isLoading: true };
    case actionTypes.DOWNLOAD_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.DOWNLOAD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPLOAD:
      return { ...state, isLoading: true };
    case actionTypes.UPLOAD_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.UPLOAD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GENERATE:
      return { ...state, isLoading: true };
    case actionTypes.GENERATE_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.GENERATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
